// Module
var code = "<button class=\"btn btn-info\" data-clipboard-text=\"{{ $ctrl.text }}\" ng-click=\"$ctrl.copy($event)\"> <sw-font-awesome icon=\"$ctrl.faCopy\"></sw-font-awesome> <span ng-bind=\"$ctrl.copyText\"></span> </button> ";
// Exports
export default code;